import { IGCSConfigProps } from "components/shard-repositories/sections/shard-repository-section/shard-repository-section";
import { IEntity, IEntityDateTime, IHasOwner, IIdName } from "./id-name";
import { IDeletedParam, IQueryStrictParams, IRequestParams } from "./page";
import { AccessCredentialsScope, AccessCredentialsScopeName } from "./access-credential";
import { DeploymentProviders } from "utils/deployment-providers-util";

export enum StorageDataType {
  Content = 1,
  Key = 2,
  Meta = 3,
}

export enum ShardRepositorySortField {
  Status = "status",
  Name = "name",
  Content = "content",
  Metadata = "metadata",
  Key = "key",
  Region = "region",
  Type = "type",
  Usage = "usage",
  Bucket = "bucket"
}

export type AllStorageProps = IS3StorageProps &
    IGoogleStorageProps &
    IAzureStorageV1Props &
    IAzureStorageV2Props;

export interface IS3StorageProps {
  key: string;
  bucket: string;
  region?: string;
  endpointURL?: string;
}

export interface IGoogleStorageProps {
  client_email: string;
  project_id: string;
  bucket: string;
  region: string;
  gcsConfigProps: IGCSConfigProps;
}

export interface IAzureStorageV1Props {
  region: string;
  container: string;
  account_name: string;
}

export interface IAzureStorageV2Props extends Pick<IAzureStorageV1Props, 'container'> {
  sasUri: string;
}


export interface IShardRepository extends IEntityDateTime<string>, IHasOwner {
  props: string;
  region: string;

  bucket?: string;
  storageType: StorageType;
  endpointURL?: string;

  types?: StorageDataType[];
  secret?: string;

  storagePools?: IIdName<string>[];
  attachmentCount?: number;
}

export type ShardRepositoryListItem = IShardRepository;

export type StorageType = "S3" | "GCS" | "ABS" | "s3p";

export interface IAddShardRepositoryRequest
    extends Omit<IUpdateShardRepositoryRequest, "id"> {
}

export interface IUpdateShardRepositoryRequest
    extends IEntity<string>, Omit<IShardRepositoryTestConnectionRequest, "secret"> {

  secret?: string;
}

export interface IShardRepositoryTestConnectionRequest
    extends AllStorageProps {

  storageType?: StorageType;
  secret: string;

}

export interface IShardRepositoryRaw extends Partial<IShardRepositoryTestConnectionRequest> {
  id?: string;
  props: string;
}

type OperationStatus = { [key in keyof typeof AccessCredentialsScope]: boolean };

export interface IShardRepositoryTestConnectionResponse {
  msg: string;
  isConnectionSuccessful: boolean;
  operationStatus: OperationStatus;
}

export interface IShardRepositoryCredentialsConfirmationData extends Pick<IShardRepositoryTestConnectionResponse, 'isConnectionSuccessful' | 'operationStatus'> {
  scope: AccessCredentialsScopeName;
}

export interface IShardRepositoryFilterParams extends IQueryStrictParams {
  storageType?: StorageType;
  pool?: string;
}

export interface IShardRepositoryRequestParams extends
    IRequestParams<ShardRepositorySortField>,
    IShardRepositoryFilterParams,
    IDeletedParam {
  fields?: (keyof IShardRepository)[];
}

export const defaultShardRepositoryFields: (keyof IShardRepository)[] = ['id', 'bucket', 'storageType', 'region'];

// region Shared Repository Update Confirmation Dialog

export interface IShardRepositoryUpdateConfirmationData {
  originalNode: ShardRepositoryListItem;
  updatedFields: IFormFields;
}

interface IFormFields {
  [fieldName: string]: string;
}

// endregion

export interface IShardRepositoryDeployRequest {
  bucket: string;
  region: string;
  provider: DeploymentProviders;
  providerId: string;
}
